import { useMemo } from 'react';

import {
  INTRODUCED_COPY,
  STANDARD_COPY,
  SUPPLY_ONLY_COPY,
  SatNoteCopy,
} from './constants';

import { useSatNoteContext } from '../../context';

interface SatNoteFormTermsHook {
  isLoading: boolean;
  copy: SatNoteCopy;
}

export default function useSatNoteFormTerms(): SatNoteFormTermsHook {
  const { isLoading, isIntroduced, isSupplyOnly } = useSatNoteContext();

  const copy = useMemo(() => {
    if (isLoading) return STANDARD_COPY;
    if (isIntroduced) return INTRODUCED_COPY;
    if (isSupplyOnly) return SUPPLY_ONLY_COPY;
    return STANDARD_COPY;
  }, [isSupplyOnly, isIntroduced, isLoading]);

  return {
    isLoading,
    copy,
  };
}
